import React, { useState } from 'react';
import '../styles/ElectroPlating.css';

export const ElectroPlatingRF = () => {
    const [inputs, setInputs] = useState({
        bathTemperature: '',
        initialCu: '',
        initialCuFoilGA: '',
        initialCuFoilGC: '',
        Thickness: '',
        Ductility: '',
        TensileStrength: '',
        throughput: '',
        platingTime: '',
        bathVolume: ''
    });

    const [results, setResults] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInputs(prev => ({
            ...prev,
            [name]: parseFloat(value) || value
        }));
    };

    const handleRunPrediction = async () => {
        setLoading(true);
        setError(null);
        try {
            const baseUrl = process.env.REACT_APP_FUNC_APP_API_BASE_URL || 'http://localhost:7071';
            const response = await fetch(`${baseUrl}/api/predict-electroplating-rf`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    bath_temperature: inputs.bathTemperature,
                    initial_cu: inputs.initialCu,
                    cufoil_ga: inputs.initialCuFoilGA,
                    cufoil_gc: inputs.initialCuFoilGC,
                    avg_thickness: inputs.Thickness,
                    avg_ductility: inputs.Ductility,
                    avg_tensile_strength: inputs.TensileStrength,
                    throughput: inputs.throughput,
                    plating_time: inputs.platingTime,
                    bath_volume: inputs.bathVolume
                })
            });

            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`);
            }

            const data = await response.json();
            setResults(data);
        } catch (err) {
            setError(err.message);
            console.error('Prediction error:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleClear = () => {
        setInputs({
            bathTemperature: '',
            initialCu: '',
            initialCuFoilGA: '',
            initialCuFoilGC: '',
            Thickness: '',
            Ductility: '',
            TensileStrength: '',
            throughput: '',
            platingTime: '',
            bathVolume: ''
        });
        setResults(null);
        setError(null);
    };

    return (
        <div className="electroplating-container">
            <div className="electroplating-header">
                ELECTROPLATING (RF) - AI/ML Model For Lab Scale
            </div>

            <div className="electroplating-content">
                {/* Input Parameters Panel */}
                <div className="input-panel">
                    <h2 className="panel-title">Input Parameters</h2>

                    <div className="input-group">
                        <label>Bath Temperature (°C)</label>
                        <input
                            type="number"
                            name="bathTemperature"
                            value={inputs.bathTemperature}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>

                    <div className="input-group">
                        <label>Initial Cu (g/l)</label>
                        <input
                            type="number"
                            name="initialCu"
                            value={inputs.initialCu}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>

                    <div className="input-group">
                        <label>Initial CuFoil GA (ml/l)</label>
                        <input
                            type="number"
                            name="initialCuFoilGA"
                            value={inputs.initialCuFoilGA}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>

                    <div className="input-group">
                        <label>Initial CuFoil GC (ml/l)</label>
                        <input
                            type="number"
                            name="initialCuFoilGC"
                            value={inputs.initialCuFoilGC}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>

                    <div className="input-group">
                        <label> Thickness (μm)</label>
                        <input
                            type="number"
                            name="Thickness"
                            value={inputs.Thickness}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>

                    <div className="input-group">
                        <label>Ductility (%)</label>
                        <input
                            type="number"
                            step="0.1"
                            name="Ductility"
                            value={inputs.Ductility}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>

                    <div className="input-group">
                        <label>Tensile Strength (MPa)</label>
                        <input
                            type="number"
                            name="TensileStrength"
                            value={inputs.TensileStrength}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>

                    <div className="input-group">
                        <label>Sigma Throughput (Ah)</label>
                        <input
                            type="number"
                            name="throughput"
                            value={inputs.throughput}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>

                    <div className="input-group">
                        <label>Plating time (s)</label>
                        <input
                            type="number"
                            name="platingTime"
                            value={inputs.platingTime}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>

                    <div className="input-group">
                        <label>Bath volume (l)</label>
                        <input
                            type="number"
                            name="bathVolume"
                            value={inputs.bathVolume}
                            onChange={handleInputChange}
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>

                    <div className="button-group">
                        <button
                            className="btn-predict"
                            onClick={handleRunPrediction}
                            disabled={loading}
                        >
                            {loading ? 'Running...' : 'Run Prediction'}
                        </button>
                        <button
                            className="btn-clear"
                            onClick={handleClear}
                            disabled={loading}
                        >
                            Clear
                        </button>
                    </div>
                </div>

                {/* Results Panel */}
                <div className="results-panel">
                    <h2 className="panel-title">Predicted Results</h2>

                    {error && (
                        <div className="error-message">
                            Error: {error}
                        </div>
                    )}

                    <table className="results-table">
                        <thead>
                            <tr>
                                <th>Output Variable</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Replenishment Rate CuFoil GA (mL/L/Ah)</td>
                                <td>{results?.GA_rate_mL_per_L_per_Ah?.toFixed(6) || ''}</td>
                            </tr>
                            <tr>
                                <td>Σ Calculated GA Volume (ml)</td>
                                <td>{results?.GA_volume_mL?.toFixed(2) || ''}</td>
                            </tr>
                            <tr>
                                <td>Replenishment Rate CuFoil GC (mL/L/Ah)</td>
                                <td>{results?.GC_rate_mL_per_L_per_Ah?.toFixed(6) || ''}</td>
                            </tr>
                            <tr>
                                <td>Σ Calculated GC Volume (ml)</td>
                                <td style={{ color: 'red', fontWeight: 'bold' }}>{results?.GC_volume_mL?.toFixed(2) || ''}</td>
                            </tr>
                        </tbody>
                    </table>

                     <div className="model-info" style={{ marginTop: '2rem', paddingTop: '1rem', borderTop: '1px solid #eee' }}>
                        <h3 style={{ color: '#1e3a5f', marginBottom: '1rem', fontSize: '18px' }}>Model Trained Parameters</h3>
                        <ul style={{ paddingLeft: '1.2rem', color: '#555', lineHeight: '1.6', fontSize: '16px', fontWeight: '500' }}>
                            <li>Bath temperature: 40 °C and 50 °C</li>
                            <li>Initial copper concentration: 70, 80, and 85 g/L</li>
                            <li>Feature size: 5 µm, 8 µm, and 18 µm</li>
                            <li>Bath volume: 12 L and 15 L</li>
                            <li>Throughput range: Trained on data up to a maximum throughput of 600</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};
